document.querySelectorAll('.page-content-nav').forEach(nav => {
  const pairs = [];
  const links = nav.querySelectorAll('a');

  links.forEach((link) => {
    const href = link.getAttribute('href');
    const id = href.replace('#', '');

    pairs.push({
      id: id,
      link: link,
      section: document.getElementById(id),
      inView: false,
    });
  });

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const id = entry.target.getAttribute('id');

      pairs.forEach(pair => {
        if (pair.id === id) {
          pair.inView = entry.isIntersecting;
        }
      });

      // Determine the active link
      const activePair = pairs.find(pair => pair.inView) || pairs.slice().reverse().find(pair => pair.section.getBoundingClientRect().top < window.innerHeight / 2);

      pairs.forEach(pair => {
        pair.link.classList.toggle('active', pair === activePair);
      });
    });
  }, { threshold: 0.5 });

  pairs.forEach(pair => {
    observer.observe(pair.section);
  });
});

document.querySelectorAll('.page-content-nav-outer').forEach(outerNav => {
  const nav = outerNav.querySelector('.page-content-nav');
  const header = document.querySelector('.header');
  const footer = document.querySelector('.footer');
  let footerVisible = false;
  let isMobile = false;
  let isContentNavFoldedOut = false

  const setSpacerHeight = () => {
    const navHeight = nav.getBoundingClientRect().height;
    outerNav.style.setProperty('--spacer-height', `${navHeight}px`);
    isMobile = window.innerWidth < 768;
  };

  const closeContentNav = () => {
    outerNav.classList.remove('mobile-content-nav-fold-out')
    isContentNavFoldedOut = false
  }

  const openContentNav = () => {
    outerNav.classList.add('mobile-content-nav-fold-out')
    isContentNavFoldedOut = true
  }

  setSpacerHeight();
  window.addEventListener('resize', setSpacerHeight);
  window.addEventListener('load', setSpacerHeight);

  const footerObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      footerVisible = entry.isIntersecting;
    });
  }, { threshold: 0.1 });

  footerObserver.observe(footer);

  // Scroll event for header interaction
  window.addEventListener('scroll', () => {
    const outerNavRect = outerNav.getBoundingClientRect();
    const headerRect = header.getBoundingClientRect();

    if (isMobile && isContentNavFoldedOut) {
      closeContentNav()
    }

    if (footerVisible) {
      isContentNavFoldedOut = false
      return outerNav.classList.remove('page-nav-sticky');
    }

    let offset = isMobile ? 0 : 50;

    if (outerNavRect.top <= (headerRect.bottom + offset)) {
      isContentNavFoldedOut = false
      outerNav.classList.add('page-nav-sticky');
    } else if (window.scrollY < (headerRect.bottom + offset)) {
      isContentNavFoldedOut = true
      outerNav.classList.remove('page-nav-sticky');
    }


  });


  nav.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', event => {
      if (isMobile && !isContentNavFoldedOut) {
        event.preventDefault()
        return openContentNav()
      }

      if (isMobile && isContentNavFoldedOut) {
        return closeContentNav()
      }

    })
  })
});

















